import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import ConfirmModal from "../../../../uq-ui/components/confirm-modal";
import { changeBrowserModalVisibilitySelector } from '../../../store/check-browser/selector';
import { hideChangeBrowserModal } from '../../../store/check-browser/actions';
import UserAgent from '../../../../uq-ui/helpers/express-useragent';
import { copyTextToClipboard } from '../../../../uq-ui/helpers/copyToClipboard';

const chromeIcon = require('./img/chrome.png');
const safariIcon = require('./img/safari.png');
class AppComponentsChangeBrowserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isIOS: false
    };
  }
  
  componentDidMount() {
    const userAgent = new UserAgent().parse(navigator.userAgent);
    this.setState({ isIOS: userAgent.isiPad || userAgent.isiPod || userAgent.isiPhone })
  }

  _renderContent() {
    let message = 'androidMessage';
    let browserIcon = chromeIcon;
    if (this.state.isIOS) {
      message = 'iosMessage';
      browserIcon = safariIcon;
    }
    return (
      <div>
        <img src={browserIcon} alt="browser icon" style={{ display: 'block', margin: '0 auto 8px auto' }}/>
        {this.props.t(message)}
      </div>
    );
  }

  copyLinkToClipboard = () => {
    copyTextToClipboard(window.location.href);
  }

  render() {
    const title = this.state.isIOS ? 'iosTitle' : 'androidTitle';
    return (
      <ConfirmModal
        show={this.props.showModal}
        title={this.props.t(title)}
        confirmLabel={this.props.t('confirm')}
        confirmBtnStyles={{ width: '80%' }}
        cancelBtnStyles={{ width: '80%' }}
        onClose={this.props.hideChangeBrowserModal}
        onConfirm={this.copyLinkToClipboard}>
        { this._renderContent() }
      </ConfirmModal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showModal: changeBrowserModalVisibilitySelector(state)
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideChangeBrowserModal: () => dispatch(hideChangeBrowserModal())
  }
};

export default compose(
  withTranslation('cmp-change-browser'),
  connect(mapStateToProps, mapDispatchToProps)
)(AppComponentsChangeBrowserModal);